import * as React from "react";
import { Badge } from "components/bootstrap";
function CVSSHeatBadge({ cvss }) {
  if (!cvss) return null;
  const badgeStyle = () => {
    if (cvss < 4 && cvss > 1) return { style: "success", text: "LOW" };
    if (cvss < 7) return { style: "info", text: "MEDIUM" };
    if (cvss < 9) return { style: "warning", text: "HIGH" };
    return { style: "danger", text: "CRITICAL" };
  };
  return /* @__PURE__ */ React.createElement(Badge, { bsStyle: badgeStyle().style }, badgeStyle().text);
}
export default CVSSHeatBadge;
